import { ReactElement, useEffect } from 'react'
import { useLoading } from '@hooks/useLoading'

const LoadingScreen = (): ReactElement | null => {
  const { isLoading, loadingMessage } = useLoading()

  // Prevent scrolling when loading screen is active
  useEffect(() => {
    if (isLoading) {
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'

      return (): void => {
        document.body.style.overflow = originalOverflow
      }
    }
  }, [isLoading])

  if (!isLoading) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-gray-500 opacity-90'>
      <div
        className={`${
          loadingMessage ? 'bg-white rounded-lg text-center shadow-lg' : ''
        } p-8`}
      >
        <div className='w-16 h-16 border-6 border-t-ut-primary border-white rounded-full animate-spin mx-auto mb-4'></div>

        {loadingMessage && (
          <p className='text-gray-700 text-lg'>{loadingMessage}</p>
        )}
      </div>
    </div>
  )
}

export default LoadingScreen
